import { instantsInterceptor, } from '@/api/index';

function getRegionAndExhaustCerti(form) {
    return instantsInterceptor.post('/mgmt/regionexhaust/list', form);
}

function saveRegionExhaustCerti(regionExList) {
    return instantsInterceptor.post('/mgmt/regionexhaust/save', regionExList);
}


export { getRegionAndExhaustCerti, saveRegionExhaustCerti };